import React from 'react';

const img = (key, fallback) =>
  (window.foxQuoteFormImages && window.foxQuoteFormImages[key]) || fallback;

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

const roofTypeImages = {
  glass:           img('conservatory_new_roof_glass',         `${BASE_URL}/conservatory-roofs/new-roof-types/glass.jpg`),
  tiled:           img('conservatory_new_roof_tiled',         `${BASE_URL}/conservatory-roofs/new-roof-types/tiled.jpg`),
  hybrid:          img('conservatory_new_roof_hybrid',        `${BASE_URL}/conservatory-roofs/new-roof-types/hybrid.jpg`),
  lantern:         img('conservatory_new_roof_lantern',       `${BASE_URL}/conservatory-roofs/new-roof-types/lantern-roof.jpg`),
  'flat-skylight': img('conservatory_new_roof_flat_skylight', `${BASE_URL}/conservatory-roofs/new-roof-types/flat-skylight.jpg`),
  'orangery-style':img('conservatory_new_roof_orangery_style',`${BASE_URL}/conservatory-roofs/new-roof-types/orangery-style.jpg`),
};

const ConservatoryRoofDimensionsStep = ({
  width,
  height,
  dontKnowDimensions,
  onWidthChange,
  onHeightChange,
  onDontKnowChange,
  errors,
  newRoofType,
}) => {
  const productImage = roofTypeImages[newRoofType] || Object.values(roofTypeImages)[0];
  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Design Specifications
      </h2>

      {/* Two Column Layout */}
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 px-4 md:grid-cols-2">
        {/* Left Column - Image */}
        <div className="relative h-[516px] overflow-hidden rounded-lg">
          <img
            src={productImage}
            alt="Conservatory Roof"
            className="h-full w-full object-cover"
          />
        </div>

        {/* Right Column - Form */}
        <div className="flex flex-col justify-center rounded-lg bg-gray-100 p-12">
          <h3 className="mb-6 text-center text-[24px] font-bold text-black">
            Enter Your Dimensions
          </h3>

          {/* Width Input */}
          <div className="mb-4">
            <label className="mb-2 block text-[15px] text-[#4c4c4c]">
              Width (metres)*
            </label>
            <input
              type="number"
              step="0.1"
              min="0"
              value={width}
              onChange={(e) => onWidthChange(e.target.value)}
              disabled={dontKnowDimensions}
              placeholder="e.g., 4.5"
              className="w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-[#252525] placeholder:text-[#9ca2ae] disabled:bg-gray-200 focus:border-[#ED6B64] focus:outline-none"
            />
            {errors?.width && (
              <p className="mt-2 text-sm text-red-500">{errors.width}</p>
            )}
          </div>

          {/* Projection Input */}
          <div className="mb-4">
            <label className="mb-2 block text-[15px] text-[#4c4c4c]">
              Projection (metres)*
            </label>
            <input
              type="number"
              step="0.1"
              min="0"
              value={height}
              onChange={(e) => onHeightChange(e.target.value)}
              disabled={dontKnowDimensions}
              placeholder="e.g., 3.0"
              className="w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-[#252525] placeholder:text-[#9ca2ae] disabled:bg-gray-200 focus:border-[#ED6B64] focus:outline-none"
            />
            {errors?.height && (
              <p className="mt-2 text-sm text-red-500">{errors.height}</p>
            )}
          </div>

          {/* Don't Know Dimensions Checkbox */}
          <div className="mb-6">
            <label className="flex cursor-pointer items-center gap-3">
              <input
                type="checkbox"
                checked={dontKnowDimensions}
                onChange={(e) => onDontKnowChange(e.target.checked)}
                className="h-6 w-6 rounded border-2 border-[#d9d9d9] text-[#ED6B64] focus:ring-[#ED6B64]"
              />
              <span className="text-[15px] text-[#4c4c4c]">
                I do not know the dimensions required.
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConservatoryRoofDimensionsStep;
